import lodash, { cloneDeep } from 'lodash'
import { justForSideEffectWithPayload } from '../../infrastructure/saga.helpers'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  DockManagementState, DocksData, CreateNewDockParams, UpdateDockManagementField,
  SetDockIsFreshPayload,
  SetDockIsFreshData,
  SetDockIsExpressData,
  SetDockIsExpressPayload,
  GetDockPayload,
  GetDocksPayload,
} from './DockManagementTypes'
import { sortDocks } from './DockManagementUtils'

const initialState: DockManagementState = {
  docks: [],
}

const getDocks = justForSideEffectWithPayload<GetDocksPayload>()
const patchDock = justForSideEffectWithPayload<number>()
const createNewDock = justForSideEffectWithPayload<CreateNewDockParams>()
const setDockIsFresh = justForSideEffectWithPayload<SetDockIsFreshPayload>()
const setDockIsExpress = justForSideEffectWithPayload<SetDockIsExpressPayload>()
const getDock = justForSideEffectWithPayload<GetDockPayload>()

const updateDockManagementField = (state, action: PayloadAction<UpdateDockManagementField>) => {
  const { key, value } = action.payload
  return { ...state, [key]: value }
}

const setDockFree = (
  state: DockManagementState,
  { payload }: PayloadAction<DocksData>,
): DockManagementState => {
  const docks = lodash.cloneDeep(state.docks)

  const indexDockToFree = docks.findIndex((dock: DocksData) => dock.id === payload.id)

  if (indexDockToFree !== -1) {
    docks[indexDockToFree].status = payload.status
  }

  return {
    ...state,
    docks,
  }
}

const addDock = (
  state: DockManagementState,
  { payload }: PayloadAction<DocksData>,
): DockManagementState => {
  const docks = [...state.docks, payload]
  const sortedDocks = sortDocks(docks)

  return {
    ...state,
    docks: sortedDocks,
  }
}

const updateDockConfig = (state: DockManagementState, action: PayloadAction<SetDockIsFreshData | SetDockIsExpressData>): DockManagementState => {
  const data = action.payload

  const cloneState = cloneDeep(state.docks)

  if (!cloneState) {
    return state
  }

  const dockIndex = cloneState.findIndex((i) => i.id === data.id)

  if (dockIndex !== -1) {
    if ('isExpress' in data) {
      cloneState[dockIndex].isExpress = data.isExpress
    }
    if ('isFresh' in data) {
      cloneState[dockIndex].isFresh = data.isFresh
    }
  }

  return {
    ...state,
    docks: cloneState,
  }
}

const slice = createSlice({
  name: 'dockManagement',
  initialState,
  reducers: {
    getDocks,
    setDockFree,
    patchDock,
    addDock,
    createNewDock,
    setDockIsFresh,
    setDockIsExpress,
    getDock,
    updateDockConfig,
    updateDockManagementField,
  },
})

export default slice.reducer

export const { actions } = slice
